
export default{
    app:{
        home_title:"Venda de Publicações dos Serviços Públicos da RAEM",
        home_address:"Endereço detalhado",
        home_lr:"Recomendações mais recentes",
        home_publisher:"Editor",
        home_publishlang:"Língua",
        home_publishdate:"Edição",
        home_search:"Título / Autor / Instituição editorial",
        home_cancel:"Cancelar ",
        home_detail_title:"Detalhes da publicação",
        home_ml:"Índice",
        home_category:"Categorias",
        home_author:"Autor",
        home_soldmaiche:"Máquina de venda",
        home_search_item :"Pesquisa",
        home_sure:"Confirmar",
        // home_selectSoldMachie:"Seleccione a máquina de venda",
        home_soldOut:"esgotado",
        home_free:"Gratuito",
        home_selectSoldMachie:"Todas as máquinas de venda",
    }
}